import { render, staticRenderFns } from "./ViParentSchoolList.vue?vue&type=template&id=e7e1552a&scoped=true"
import script from "./ViParentSchoolList.vue?vue&type=script&lang=js"
export * from "./ViParentSchoolList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e1552a",
  null
  
)

export default component.exports